import type { ResearchOverview } from "../api/research";
import { usePollingResource } from "./usePollingResource";

export function useResearchStatus() {
  return usePollingResource<ResearchOverview>("/research/overview", 30_000);
}
